import { useFormik } from "formik"
import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
//redux
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import {
  deleteOrder as onDeleteOrder,
  getOrders as onGetOrders,
} from "store/actions"
import * as Yup from "yup"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import { settingslist, employeeList } from "../../../common/data/settings"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//import components
import DeleteModal from "../../../components/Common/DeleteModal"
import ManageSettingsTableContainer from "../Components/ManageSettingsTableContainer"
import EcommerceOrdersModal from "./ManageEmployeeModal"
import {
  EmpName,
  EmpEmail,
  EmpPhone,
} from "pages/Admin/ManageEmployee/ManageEmployeeCol"

function ManageEmployee() {
  //meta title
  document.title =
    "ManageSettings | TenderSoftware - Flexi TracBoard"

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const [orderList, setOrderList] = useState([])
  const [order, setOrder] = useState(null)

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (order && order?.name) || "",
      email: (order && order?.email) || "",
      phone: (order && order?.phone) || "",

  
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Please enter your name"),
      email: Yup.string().required("Please enter your email"),
      phone: Yup.string().required("Please enter your phone number"),
    }),

    onSubmit: values => {
      toggle();
      validation.resetForm()
    },
  })

  const toggleViewModal = () => setModal1(!modal1)

  const dispatch = useDispatch()
  // const { orders } = useSelector(state => ({
  //   orders: state.ecommerce.orders,
  // }))

  const orders = employeeList

  useEffect(() => {
    if (orders && !orders.length) {
      dispatch(onGetOrders())
    }
  }, [dispatch, orders])

  useEffect(() => {
    setOrderList(orders)
  }, [orders])

  useEffect(() => {
    if (!isEmpty(orders) && !!isEdit) {
      setOrderList(orders)
      setIsEdit(false)
    }
  }, [orders])

  
  const toggle = () => {    
    if (modal) {
      setModal(false)
      setOrder(null)
    } else {
      setModal(true)
    }
  }

  const handleOrderClick = arg => {
    const order = arg
    setOrder({
      id: order.id,
      name: order.name,
      email: order.email,
      phone: order.phone,
    })

    setIsEdit(true)
    toggle()
  }

  //delete order
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = order => {
    setOrder(order)
    setDeleteModal(true)
  }

  const handleDeleteOrder = () => {
    if (order.id) {
      dispatch(onDeleteOrder(order))
      setDeleteModal(false)
    }
  }
  const handleOrderClicks = () => {
    setOrderList("")
    setIsEdit(false)
    toggle()
  }

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        filterable: true,
        Cell: cellProps => {
          return <EmpName {...cellProps} />
        },
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: true,
        Cell: cellProps => {
          return <EmpEmail {...cellProps} />
        },
      },
      {
        Header: "Phone",
        accessor: "phone",
        filterable: true,
        Cell: cellProps => {
          return <EmpPhone {...cellProps} />
        },
      },

      // {
      //   Header: "View Details",
      //   accessor: "view",
      //   disableFilters: true,
      //   Cell: () => {
      //     return (
      //       <Button
      //         type="button"
      //         color="primary"
      //         className="btn-sm btn-rounded"
      //         onClick={toggleViewModal}
      //       >
      //         View Details
      //       </Button>
      //     )
      //   },
      // },

      {
        Header: "Action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div
              onClick={e => {
                console.log("Stop Propagation ")
                e.stopPropagation()
              }}
            >
              <UncontrolledDropdown>
                <DropdownToggle href="#" className="card-drop pointer" tag="a">
                  <i className="mdi mdi-dots-horizontal font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <div className="">
                    <div className="py-2 px-3">
                      <Link
                        to="#"
                        className="text-muted"
                        onClick={() => {
                          const orderData = cellProps.row.original
                          handleOrderClick(orderData)
                        }}
                      >
                        <i
                          className="mdi mdi-pencil font-size-18 me-2"
                          id="edittooltip"
                        />
                        Edit
                      </Link>
                    </div>
                    {/* <div className="py-2 px-3">
                      <Link
                        to="#"
                        className="text-muted"
                        onClick={() => {
                          const orderData = cellProps.row.original
                          onClickDelete(orderData)
                        }}
                      >
                        <i
                          className="mdi mdi-delete font-size-16 me-2"
                          id="deletetooltip"
                        />
                        Disable
                      </Link>
                    </div> */}

                    <div className="py-2 px-3">
                      <Link
                        to="#"
                        className="text-muted"
                        onClick={() => {
                          const orderData = cellProps.row.original
                          onClickDelete(orderData)
                        }}
                      >
                        <i
                          className="mdi mdi-delete font-size-16 me-2"
                          id="deletetooltip"
                        />
                        Reset Password
                      </Link>
                    </div>


                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={"Manage Employees"}
            breadcrumbItem={"Manage Employees"}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <ManageSettingsTableContainer
                    columns={columns}
                    data={orders}
                    isGlobalFilter={false}
                    isAddOptions={true}
                    handleOrderClick={handleOrderClick}
                    customPageSize={15}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={modal} toggle={toggle}>
        
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Settings" : "Add Order"}
            </ModalHeader>

            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}>

                <Row form>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Name</Label>
                      <Input
                        name="name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={
                          validation.touched.name && validation.errors.name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">Email</Label>
                      <Input
                        name="email"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email
                            ? true
                            : false
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">
                          {validation.errors.email}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Phone</Label>
                      <Input
                        name="phone"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.phone || ""}
                        invalid={
                          validation.touched.phone && validation.errors.phone
                            ? true
                            : false
                        }
                      />
                      {validation.touched.phone && validation.errors.phone ? (
                        <FormFeedback type="invalid">
                          {validation.errors.phone}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-primary save-user"
                      >
                        Save
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
ManageEmployee.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default ManageEmployee
